import { combineReducers } from 'redux'
import * as actions from '../actions'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  items: [],
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_CATEGORIES_TAGS_REQUEST],
  falseTypes: [
    actions.GET_CATEGORIES_TAGS_SUCCESS,
    actions.GET_CATEGORIES_TAGS_FAILURE,
  ],
})

const items = (state = initialState.items, { type, payload }) => {
  if (type === actions.GET_CATEGORIES_TAGS_SUCCESS) {
    return [...payload]
  }
  return state
}

export default combineReducers({
  isFetching,
  items,
})



// WEBPACK FOOTER //
// ./src/reducers/tags.js